import React, { useMemo, useState } from 'react'
import { Switch, Route, useRouteMatch } from 'react-router-dom'
import HomeLayout from '../../layouts/home'
import { Wrapper } from './styled'
import { SideBar } from '../components'
import TaskScreen from '..'
import TaskCreateScreen from '../create'
import TaskEditScreen from '../edit'
import PageNotFound from '../../page-not-fount'

export const TaskLayout = () => {
  const { path } = useRouteMatch()

  const [items, setItems] = useState([])
  const [isModalActionVisible, setIsModalActionVisible] = useState(false)
  const isSelectedAll = useMemo(
    () => (items.length === 0 || items.filter(({ isRequesterMe }) => isRequesterMe).length === 0 ? false : items.filter(({ isRequesterMe }) => isRequesterMe).every((item) => item.selected)), [items]
  )
  const isSelectedSome = useMemo(() => items.some((item) => item.selected), [items])

  return (
    <HomeLayout>
      <Wrapper>
        <SideBar isSelectedSome={isSelectedSome} setIsModalActionVisible={setIsModalActionVisible} />

        <Switch>
          <Route exact path={path}>
            <TaskScreen
              items={items}
              setItems={setItems}
              isSelectedAll={isSelectedAll}
              isModalActionVisible={isModalActionVisible}
              setIsModalActionVisible={setIsModalActionVisible}
            />
          </Route>
          <Route
            exact
            path={`${path}/create`}
            component={TaskCreateScreen}
          />
          <Route
            path={`${path}/edit/:taskId`}
            component={TaskEditScreen}
          />
          <Route component={PageNotFound} />
        </Switch>
      </Wrapper>
    </HomeLayout>
  )
}
